import type { ConceptCategory, ConceptDef } from '../types';

const trace = (id: string, label: string, category: ConceptCategory, description: string, items: string[]): ConceptDef => ({
  kind: 'traceIt',
  id,
  label,
  category,
  description,
  config: { guide: 'trace', trialOrder: 'fixed', prompts: items.map((prompt) => ({ prompt })) },
});

export const traceCapitals = trace('trace-capitals', 'Trace Capital Letters', 'Literacy', 'Trace each capital letter, A to Z, over a clear outline.', 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split(''));
export const traceSmall = trace('trace-small-letters', 'Trace Small Letters', 'Literacy', 'Trace each small letter, a to z, over a clear outline.', 'abcdefghijklmnopqrstuvwxyz'.split(''));
export const traceNumbers = trace('trace-numbers', 'Trace Numbers', 'Math', 'Trace each number, 0 to 9, over a clear outline.', '0123456789'.split(''));
